// 產品介面使用下載的透明背景 Xsenal 原圖，深淺主題共用；公司／帳單識別使用 MomentX。
export const XSENAL_BRAND = {
  markLight: '/images/brand/xsenal.png',
  markDark: '/images/brand/xsenal.png',
  fullLight: '/images/brand/xsenal.png',
  fullDark: '/images/brand/xsenal.png',
} as const;

export const MOMENTX_BRAND = {
  mark: '/logo.svg',
} as const;
